import { NgModule, ModuleWithProviders } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ShellComponent } from './shell.component';
import { KngShellModule, ModalModule, KngLoaderModule } from 'kinetic-angular';
import { ShellService } from './shell.service';
import { RouterModule } from '@angular/router';
import { MatTooltipModule } from '@angular/material/tooltip';
import { LoggerServiceModule } from '../../services/logger/logger.module';
import{ SafeHtmlPipeModule } from '../../../app/pipes/safehtml/safehtml.pipe.module';
import { FormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { ToastrModule } from 'ngx-toastr';
import { KngBannerModule } from 'projects/kinetic-angular/src/lib/components/banner';
import { MatRadioModule } from '@angular/material/radio';
@NgModule({
	declarations: [ShellComponent],
	imports: [ CommonModule, KngShellModule, RouterModule, KngLoaderModule, ModalModule, MatTooltipModule, LoggerServiceModule, SafeHtmlPipeModule, FormsModule, MatCheckboxModule, KngBannerModule, MatRadioModule,
		ToastrModule.forRoot({
			preventDuplicates: true,
			closeButton: true
		}) ],
	exports: [ShellComponent],
	providers: [ShellService]
})
export class ShellModule
{
	static forRoot(): ModuleWithProviders<ShellModule>
	{
		return {
			ngModule: ShellModule,
			providers: [ShellService]
		};
	}
}

